export function toPaginationOptions(_a) {
    var sort = _a.sort, paginator = _a.paginator;
    return {
        orderBy: sort ? sort.active + "_" + sort.direction : undefined,
        limit: paginator.pageSize,
        offset: paginator.pageIndex * paginator.pageSize
    };
}
